export function capitalizeFirstLetter(string?: string): string {
  if (!string) return '';

  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function formatStringList(elements: string[] | null): string {
  if (elements === null) {
    return '';
  }
  const formattedElements = elements.map((element) => {
    if (element.length > 0) {
      return capitalizeFirstLetter(element);
    }
    return '';
  });
  return formattedElements.join(', ');
}
